
export default function Panel_Cases_Search_P()
{
  return (
    <div>
      <h1>جستجو فایل</h1>
    </div>
  );
}
